import { I18N } from "oc-I18N";
import { useQuerystring } from "../hooks/useQuerystring";

export const WarenkorbButton = () => {
  const { code, target, endUrl } = useQuerystring();
  const show = endUrl?.length > 0 && code?.length > 0;
  const url = endUrl?.replace("{Code}", code);

  return show ? (
    <a
      href={url}
      target={target}
      className="primary-button fertig-button font-size-1"
      aria-label={I18N("aria::Zum Warenkorb")}
      role="button"
    >
      <i className="icon icon-cart" aria-hidden="true"></i>
      {I18N("Warenkorb")}
    </a>
  ) : (
    <></>
  );
};
